import React from 'react';
import { Icon } from './Icon.js';
export const IconChartBarArrowUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10 20L10 9L7 8L11.5 2L12.5 2L17 8L14 9L14 20L10 20Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M18 13H22V20H18V13Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M2 16H6V20H2V16Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconChartBarArrowUp.js.map